<template>
  <v-row no-gutters>
    <v-col cols="12">
      <BankSelect :emitSelectBank.sync="bank" />
    </v-col>
    <v-col cols="12" class="mt-3">
      <p class="mb-1 text-left">계좌번호</p>
      <v-text-field
        v-model="accountNo"
        solo
        single-line
        hide-details
        outlined
        flat
        autocomplete="on"
        placeholder="계좌번호"
      ></v-text-field>
    </v-col>
    <v-col cols="12" class="mt-5">
      <BasicButton
        :loading="isLoading"
        :disabled="isLoading || bankIsValid === false"
        @click="getAccountName()"
        id="btn__OwA7ya7aUEivje/GLcmzlQ=="
      >
        계좌 조회하기
      </BasicButton>
      <p class="mt-1 color--pinkred-110 text-left">
        * 적금, 휴먼 계좌의 경우 송금이 불가능하오니 예금 계좌로 입력해주세요.
      </p>
    </v-col>

    <v-col cols="12" v-if="accountName">
      <p class="mb-1 text-left">예금주</p>
      <v-text-field
        solo
        single-line
        hide-details
        outlined
        flat
        disabled
        autocomplete="on"
        :value="accountName"
      ></v-text-field>
    </v-col>

    <v-col cols="12" style="margin-top: 3rem">
      <BasicButton
        :loading="isLoading"
        :disabled="isLoading || isValidAll === false"
        @click="registerAccount()"
        id="btn__+Zy41nC3xUKEZ+WtocKO5Q=="
      >
        계좌 등록하기
      </BasicButton>
    </v-col>
  </v-row>
</template>

<script>
import { defaultApi } from '@/plugins/api/defaultApi'
import BankSelect from '../bank/BankSelect.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    BankSelect,
  },
  data() {
    return {
      isLoading: false,
      bank: null,
      accountNo: null,
      accountName: null,
    }
  },
  watch: {
    bank: {
      deep: true,
      handler() {
        this.accountName = null
      },
    },
    accountNo() {
      this.accountName = null
    },
  },
  computed: {
    bankIsValid() {
      return !!this.bank && !!this.accountNo
    },
    isValidAll() {
      return this.bankIsValid && this.accountName !== null
    },
  },
  methods: {
    ...mapActions('auth', ['getMe']),
    async getAccountName() {
      if (this.bankIsValid !== true) {
        return
      }

      const confirm = await this.$swal.basic.confirm('계좌 조회를 진행합니다')

      if (confirm.isConfirmed !== true) {
        return
      }

      this.isLoading = true

      try {
        const { data } = await defaultApi.getBankAccountHolderName({
          bank: this.bank.bank,
          number: this.accountNo,
        })

        const result = data.holderName
        this.accountName = result

        this.$swal.basic.alert({
          html: `예금주 <br /> <br /> 
              <b class="font--m-4">
                ${result}
              </b>
              <br />
              <br />
              위 정보가 맞는지 확인 후 진행해주세요
              `,
        })
      } finally {
        this.isLoading = false
      }
    },
    async registerAccount() {
      if (this.isValidAll !== true) {
        return
      }

      const confirm = await this.$swal.basic.confirm('계좌 등록을 진행합니다')

      if (confirm.isConfirmed !== true) {
        return
      }

      this.isLoading = true

      try {
        const { data } = await defaultApi.postBankAccounts({
          bank: this.bank.bank,
          number: this.accountNo,
        })

        await this.$swal.basic.alert('계좌가 정상적으로 등록되었습니다.')
        await this.getMe()
        // 메인페이지나 다음 경로가 있으면 다음페이지로 보냄
        this.$router.replace({ name: 'main' })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
